/** What each access role is called on screen, everywhere (never the raw "superadmin" or "exec"). */
export const ROLE_LABEL: Record<string, string> = {
  superadmin: "Administrator",
  exec: "Team member",
  client: "Client",
  readonly: "Read-only",
};
export const roleLabel = (role: string | null | undefined) => (role ? ROLE_LABEL[role] || role : "");
